import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';

import AsyncSelector from 'common/components/selectors/AsyncSelector';
import { getAsyncOptions, getInitialAsyncValues } from 'utils/helpers';
import CircledButton from 'common/components/buttons/CircledButton';
import RequestedValue from '../components/RequestedValue';
import CombinedAggragate from '../components/CombinedAggragate';

const Default = ({ selectField, changeField, onRemove, fields, showHeader, isEditDisabled }) => {
  const hasAggregation = fields.aggregation_type?.value;
  const isCombinedAggrate = fields.aggregation_type?.value?.label === 'combined_aggregate';

  return (
    <Row className={'cmt-4'}>
      <Col xs={4}>
        <AsyncSelector
          onChange={selectField('aggregation_type')}
          type="aggregation-types"
          disabled={isEditDisabled}
          className={`${fields.aggregation_type?.error ? 'mb-1' : 'mb-0'}`}
          getOptionValue={option => option.label}
          getOptionLabel={option => option.name}
          loadOptions={search => getAsyncOptions(search, 'aggregation-types', {}, false)}
          defaultOptions={() => getInitialAsyncValues('aggregation-types', null, null)}
          isClearable={false}
          {...fields.aggregation_type}
        />
      </Col>

      {hasAggregation ? (
        <>
          {isCombinedAggrate ? (
            <Col xs={4}>
              <CombinedAggragate
                selectField={selectField}
                fields={fields}
                isEditDisabled={isEditDisabled}
              />
            </Col>
          ) : (
            <Col xs={4}>
              <AsyncSelector
                disabled={isEditDisabled}
                onChange={selectField('rank')}
                type="crew-ranks"
                getOptionValue={option => option.id}
                getOptionLabel={option => option.name}
                className={`${fields.rank?.error ? 'mb-1' : 'mb-0'}`}
                loadOptions={search => getAsyncOptions(search, 'crew-ranks')}
                defaultOptions={() => getInitialAsyncValues('crew-ranks', null, null)}
                isClearable={false}
                {...fields.rank}
              />
            </Col>
          )}

          <Col>
            <RequestedValue
              changeField={changeField}
              fields={fields}
              showHeader={showHeader}
              isEditDisabled={isEditDisabled}
            />
          </Col>
        </>
      ) : null}

      {isEditDisabled ? null : (
        <Col xs="auto" className="ms-auto">
          <CircledButton
            onClick={onRemove}
            type="remove"
            className="remove-icon"
            svgStyle={{ width: 6, height: 6 }}
            style={{ width: 16, height: 16 }}
          />
        </Col>
      )}
    </Row>
  );
};

export default Default;

Default.propTypes = {
  selectField: PropTypes.func.isRequired,
  changeField: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  showHeader: PropTypes.bool,
  isEditDisabled: PropTypes.bool,
  fields: PropTypes.shape({
    aggregation_type: PropTypes.shape({ value: PropTypes.object, error: PropTypes.string }),
    rank: PropTypes.shape({ value: PropTypes.object, error: PropTypes.string }),
    second_rank: PropTypes.shape({ value: PropTypes.object, error: PropTypes.string }),
    threshold: PropTypes.shape({ value: PropTypes.string, error: PropTypes.string }),
    type_id: PropTypes.shape({ value: PropTypes.number, error: PropTypes.string })
  })
};
